<template>
  <div
    class="ps-4 pe-md-4"
    :class="{
      'border-top mt-3':
        workHistoryStore.candidate_resume_work_histories &&
        workHistoryStore.candidate_resume_work_histories.length > 0,
    }"
  >
    <div
      v-for="(item, idx) in fields"
      :key="idx"
      class="history-experience flex-column flex-md-row-reverse d-flex justify-content-end"
    >
      <div class="d-flex justify-content-end align-items-center mt-3 ps-md-4">
        <img
          alt="Remove icon"
          class="h-29x w-29x cursor-pointer"
          src="@/assets/images/icons/remove-icon.svg"
          @click="removeItemForAdditionalInformation(idx)"
        />
      </div>
      <div class="col-md-11 pt-md-4">
        <div class="pe-3 pe-md-0">
          <div
            class="form-label d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
          >
            <label for="school-name" class="size-12">企業名（{{ idx + 2 }}社目）</label>
            <span class="tag-thirdly size-10 ms-2">必須</span>
          </div>
          <div class="col-12">
            <!-- input 1 -->
            <Field
              v-slot="{ field, errors }"
              :name="`candidate_resume_work_histories[${idx}].corporation_name`"
            >
              <input
                type="text"
                class="input-primary form-control bg-silver-primary size-14 border-0"
                v-bind="field"
                :class="{ 'is-invalid': !!errors.length }"
                placeholder="会社名"
                @change="onChangeExperience(item, idx)"
              />
              <div class="d-block invalid-feedback mt-0">{{ errors[0] }}</div>
              <div class="d-flex justify-content-end mt-2 text-black-50 size-10">
                <span>0/100（最大文字数100文字）</span>
              </div>
            </Field>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row pt-md-3 gap-3">
          <div class="col-md-7 d-flex flex-column flex-md-row gap-3">
            <div class="input-group row pe-0 pe-md-3">
              <div class="form-label d-flex align-items-center">
                <label class="size-12" for="">入社年月</label>
                <span class="tag-thirdly size-10 ms-2">必須</span>
              </div>
              <div class="col-6 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="`candidate_resume_work_histories[${idx}].from_year`"
                >
                  <select
                    class="form-select select-input-primary size-14"
                    :class="{ 'is-invalid': !!errors.length }"
                    v-bind="field"
                    @change="onChangeExperience(item, idx)"
                  >
                    <option value="" disabled selected>年</option>
                    <option
                      v-for="e in getListNumber(1950, new Date().getFullYear()).reverse()"
                      :key="e"
                      :value="e"
                    >
                      {{ e }}
                    </option>
                  </select>
                  <div class="d-block invalid-feedback mt-0">{{ errors[0] }}</div>
                </Field>
              </div>
              <div class="col-6 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="`candidate_resume_work_histories[${idx}].from_month`"
                >
                  <select
                    class="form-select select-input-primary size-14"
                    :class="{ 'is-invalid': !!errors.length }"
                    v-bind="field"
                    @change="onChangeExperience(item, idx)"
                  >
                    <option value="" disabled selected>月</option>
                    <option v-for="e in getListNumber(1, 12)" :key="e" :value="e">
                      {{ e }}
                    </option>
                  </select>
                  <div class="d-block invalid-feedback mt-0">{{ errors[0] }}</div>
                </Field>
              </div>
            </div>
            <div class="input-group row pe-0 pe-md-3">
              <div class="form-label">
                <label class="size-12" for="">退社年月</label>
              </div>
              <div class="col-6 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="`candidate_resume_work_histories[${idx}].to_year`"
                >
                  <select
                    class="form-select select-input-primary size-14"
                    :class="{ 'is-invalid': !!errors.length }"
                    v-bind="field"
                    @change="onChangeExperience(item, idx)"
                  >
                    <option value="" disabled selected>年</option>
                    <option
                      v-for="e in getListNumber(1950, new Date().getFullYear()).reverse()"
                      :key="e"
                      :value="e"
                    >
                      {{ e }}
                    </option>
                  </select>
                  <div class="d-block invalid-feedback mt-0">{{ errors[0] }}</div>
                </Field>
              </div>
              <div class="col-6 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="`candidate_resume_work_histories[${idx}].to_month`"
                >
                  <select
                    class="form-select select-input-primary size-14"
                    v-bind="field"
                    :class="{ 'is-invalid': !!errors.length }"
                    @change="onChangeExperience(item, idx)"
                  >
                    <option value="" disabled selected>月</option>
                    <option v-for="e in getListNumber(1, 12)" :key="e" :value="e">
                      {{ e }}
                    </option>
                  </select>
                  <div class="d-block invalid-feedback mt-0">{{ errors[0] }}</div>
                </Field>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="input-group row pe-0 pe-md-1">
              <div class="col-12 pe-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="`candidate_resume_work_histories[${idx}].employment_type_id`"
                >
                  <div class="form-label d-flex align-items-center">
                    <label class="size-12" for="">雇用形態</label>
                    <span class="tag-thirdly size-10 ms-2">必須</span>
                  </div>
                  <select
                    class="form-select select-input-primary size-14"
                    :class="{ 'is-invalid': !!errors.length }"
                    v-bind="field"
                    @change="onChangeExperience(item, idx)"
                  >
                    <option value="" disabled selected>選択してください</option>
                    <option
                      v-for="employmentType in props.employmentTypes"
                      :key="employmentType.id"
                      :value="employmentType.id"
                    >
                      {{ employmentType.name }}
                    </option>
                  </select>
                  <div class="d-block invalid-feedback mt-0">{{ errors[0] }}</div>
                </Field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center col-md-12 mt-4">
      <div v-if="(workHistoryStore.candidate_resume_work_histories?.length ?? 0) < 9">
        <AddButton
          class="mw-184x h-36x"
          title="経験企業を追加する"
          @click="addItemForAdditionalInformation()"
        />
        <p class="d-flex justify-content-center text-secondary pe-2 pt-1 size-12">※ 10社まで</p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { PropType, watch, onMounted } from 'vue';
import { Field, useFieldArray } from 'vee-validate';
import getListNumber from '@/utils/getListNumber';
import { useWorkHistoryStore } from '@/stores/resume-candidate/WorkHistory.store';
import { EmploymentTypePrimary } from '@/types/models/employmentType';
import AddButton from '@/components/common/Button/AddButton/index.vue';
import { ExperienceCompany } from '@/types/pages/ExperienceCompany';

const { replace, fields }: any = useFieldArray('candidate_resume_work_histories');
const workHistoryStore = useWorkHistoryStore();

onMounted(() => {
  replaceWorkHistory();
});

watch(
  () => workHistoryStore.candidate_resume_work_histories,
  () => {
    replaceWorkHistory();
  }
);

const replaceWorkHistory = (): void => {
  replace(
    workHistoryStore.candidate_resume_work_histories?.map((item: ExperienceCompany) => {
      return { ...item };
    })
  );
};

const addItemForAdditionalInformation = (): void => {
  if ((workHistoryStore.candidate_resume_work_histories?.length ?? 0) < 9) {
    workHistoryStore.candidate_resume_work_histories?.push({
      corporation_name: '',
      from_year: undefined,
      from_month: undefined,
      to_year: undefined,
      to_month: undefined,
      employment_type_id: undefined,
      years_of_service: undefined,
    });
    replaceWorkHistory();
  }
};

const removeItemForAdditionalInformation = (idx: number): void => {
  if (workHistoryStore.candidate_resume_work_histories) {
    workHistoryStore.candidate_resume_work_histories =
      workHistoryStore.candidate_resume_work_histories.filter((_, i) => i !== idx);
  }
};

const onChangeExperience = (item: any, idx: number): void => {
  if (workHistoryStore.candidate_resume_work_histories)
    workHistoryStore.candidate_resume_work_histories[idx] = item.value;
};

const props = defineProps({
  employmentTypes: {
    type: Array as PropType<Array<EmploymentTypePrimary>>,
    required: false,
    default: () => [],
  },
});
</script>
